const dateFormat = require('dateformat');

const OPTIONS =  [
    {id: 0, label: 'Today', from: 'now/d', to: 'now'},
    {id: 1, label: 'Last 24h', from: 'now-1d', to: 'now'},
    {id: 2, label: 'Yesterday', from: 'now-1d/d', to: 'now/d'},
    {id: 3, label: 'Last 3 days', from: 'now-3d', to: 'now'},
    {id: 4, label: 'Last 7 days', from: 'now-7d', to: 'now'},
    {id: 5, label: 'This month', from: 'now/M', to: 'now'},
    {id: 6, label: 'Last 30 days', from: 'now-30d', to: 'now'},
    {id: 7, label: 'Last month', from: 'now-1M/M', to: 'now/M'},
    {id: 8, label: 'This year', from: 'now/y', to: 'now'},
    {id: 9, label: 'Last year', from: 'now-1y/y', to: 'now/y'},
    {id: 10, label: 'Custom time period', from: 'now-(\\d+)([dMy])', to: 'now'},
    {id: 11, label: 'Default - fixed range'}
];

const API_DATE_FORMAT = /^now(-(\d+)([hdMy])(\/[hdMy])?)?$/;

const UNITS = {
    'h': 'hours',
    'd': 'days',
    'M': 'months',
    'y': 'years'
};

const timeRanges = {
    findTimeRangeLabel: function(from, to) {
        if (!from && !to) {
            return null;
        }

        const option = findOption(from, to);

        return !option ? null : parseTimeRange(option, from, to);
    }
};

function findOption(from, to) {
    return OPTIONS.find(el => {
        let fromFilter = !el.from;
        let toFilter = !el.to;

        if (el.from && new RegExp(`^${el.from}$`).test(from)) {
            fromFilter = true;
        }

        if (el.to && new RegExp(`^${el.to}$`).test(to)) {
            toFilter = true;
        }

        return fromFilter && toFilter;
    });
}

function parseTimeRange(option, from, to) {
    switch (option.id) {
        case 10:
            return parseCustomTimePeriod(option, from);

        case 11:
            return parseToFixedRangeTimePeriod(option, from, to);

        default:
            return option.label;
    }
}

function parseCustomTimePeriod(option, from) {
    const execFromResult = new RegExp(`^${option.from}$`).exec(from);

    return `Last ${execFromResult[1]} ${UNITS[execFromResult[2]]}`;
}

function parseToFixedRangeTimePeriod(option, from, to) {
    const [,, fromAmount, fromUnit, fromStartDateUnit] = API_DATE_FORMAT.exec(from) || [];
    const [,, toAmount, toUnit, toStartDateUnit] = API_DATE_FORMAT.exec(to) || [];

    const parsedFrom = fromAmount ? parseByUnit(fromAmount, fromUnit, fromStartDateUnit) : parseFixedDateRange(from);
    const parsedTo = toAmount ? parseByUnit(toAmount, toUnit, toStartDateUnit) : parseFixedDateRange(to);

    return `${parsedFrom} - ${parsedTo}`;
}

function parseByUnit(amount, unit, forceStart) {
    const date = new Date();
    let format;

    switch(unit) {
        case 'h':
            format = forceStart ? 'yyyy-mm-dd HH:00' : 'yyyy-mm-dd HH:MM';
            return dateFormat(date.setHours(date.getHours() - amount), format, true);

        case 'd':
            format = forceStart ? 'yyyy-mm-dd 00:00' : 'yyyy-mm-dd HH:MM';
            return dateFormat(date.setDate(date.getDate() - amount), format, true);

        case 'M':
            format = forceStart ? 'yyyy-mm-01 00:00' : 'yyyy-mm-dd HH:MM';
            return dateFormat(date.setMonth(date.getMonth() - amount), format, true);

        case 'y':
            format = forceStart ? 'yyyy-01-01 00:00' : 'yyyy-mm-dd HH:MM';
            return dateFormat(date.setFullYear(date.getFullYear() - amount), format, true);

        default:
            return 'Invalid Date';
    }
}

function parseFixedDateRange(date) {
    return date === 'now' ? date : dateFormat(date, 'yyyy-mm-dd HH:MM', true);
}

export default timeRanges;



// WEBPACK FOOTER //
// ./src/store/TimeRanges.js